// library
import { ArSymbol } from '@aceroll/core/library';

// game-objects
import { Bonus } from '../game-objects/slot/symbols/bonus';
import { Expand } from '../game-objects/slot/symbols/expand';
import { Multiplier } from '../game-objects/slot/symbols/multiplier';

export const symbolsMap = new Map([
	['0', { // wild
		symbol: Expand,
		config: {
			type: 'wild',
			valuable: 0,
			overMask: true,
			default: {
				static: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-wild'
				},
				dimm: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-wild_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-wild_blur'
				},
				spine: {
					shift: {
						x: 0,
						y: 0
					},
					src: 'spine-symbol_wild',
					animations: {
						land: 'landing',
						expand: 'win',
						idleB: 'idle_b',
						idleS: 'idle_s',
						win: 'idle_b'
					},
					skin: 'default'
				},
				sounds: {
					win: 'wild-trigger',
					expand: 'wild-expand-action',
					land: 'wild-trigger'
				}
			}
		}
	}],
	['1', { //10
		symbol: ArSymbol,
		config: {
			type: 'low',
			valuable: 1,
			default: {
				static: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_1'
				},
				dimm: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_1_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_1_blur'
				},
				spine: {
					shift: {
						x: -1,
						y: 1
					},
					src: 'spine-symbol_low',
					animations: {
						win: 'win_10'
					},
					skin: 'default'
				},
				sounds: {
					win: 'low',
					cheap: 'low_cheap'
				}
			}
		}
	}],
	['2', { // j
		symbol: ArSymbol,
		config: {
			type: 'low',
			valuable: 2,
			default: {
				static: {
					shift: {
						x: 0,
						y: -2
					},
					texture: 'symbols-sym_2'
				},
				dimm: {
					shift: {
						x: 0,
						y: -2
					},
					texture: 'symbols-sym_2_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: -2
					},
					texture: 'symbols-sym_2_blur'
				},
				spine: {
					shift: {
						x: -1,
						y: 6
					},
					src: 'spine-symbol_low',
					animations: {
						win: 'win_j'
					},
					skin: 'default'
				},
				sounds: {
					win: 'low',
					cheap: 'low_cheap'
				}
			}
		}
	}],
	['3', { //q
		symbol: ArSymbol,
		valuable: 3,
		config: {
			type: 'low',
			valuable: 3,
			default: {
				static: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_3'
				},
				dimm: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_3_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_3_blur'
				},
				spine: {
					shift: {
						x: -4,
						y: 2
					},
					src: 'spine-symbol_low',
					animations: {
						win: 'win_q'
					},
					skin: 'default'
				},
				sounds: {
					win: 'low',
					cheap: 'low_cheap'
				}
			}
		}
	}],
	['4', { //k
		symbol: ArSymbol,
		config: {
			type: 'low',
			valuable: 4,
			default: {
				static: {
					shift: {
						x: 0,
						y: -1
					},
					texture: 'symbols-sym_4'
				},
				dimm: {
					shift: {
						x: 0,
						y: -1
					},
					texture: 'symbols-sym_4_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: -1
					},
					texture: 'symbols-sym_4_blur'
				},
				spine: {
					shift: {
						x: -4,
						y: 4
					},
					src: 'spine-symbol_low',
					animations: {
						win: 'win_k'
					},
					skin: 'default'
				},
				sounds: {
					win: 'low',
					cheap: 'low_cheap'
				}
			}
		}
	}],
	['5', { //a
		symbol: ArSymbol,
		config: {
			type: 'low',
			valuable: 5,
			default: {
				static: {
					shift: {
						x: 0,
						y: -1
					},
					texture: 'symbols-sym_5'
				},
				dimm: {
					shift: {
						x: 0,
						y: -1
					},
					texture: 'symbols-sym_5_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: -1
					},
					texture: 'symbols-sym_5_blur'
				},
				spine: {
					shift: {
						x: 0,
						y: 5
					},
					src: 'spine-symbol_low',
					animations: {
						win: 'win_a'
					},
					skin: 'default'
				},
				sounds: {
					win: 'low',
					cheap: 'low_cheap'
				}
			}
		}
	}],
	['6', {// hight
		symbol: ArSymbol,
		config: {
			type: 'high',
			valuable: 6,
			default: {
				static: {
					shift: {
						x: 1,
						y: 0
					},
					texture: 'symbols-sym_7'
				},
				dimm: {
					shift: {
						x: 1,
						y: 0
					},
					texture: 'symbols-sym_7_dimm'
				},
				spin: {
					shift: {
						x: 1,
						y: 0
					},
					texture: 'symbols-sym_7_blur'
				},
				spine: {
					shift: {
						x: 0,
						y: -1
					},
					src: 'spine-symbol_h2',
					animations: {
						win: 'win'
					},
					skin: 'default'
				},
				sounds: {
					win: 'high_1',
					cheap: 'high_1_cheap'
				}
			}
		}
	}],
	['7', {// hight
		symbol: ArSymbol,
		config: {
			type: 'high',
			valuable: 7,
			default: {
				static: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_8'
				},
				dimm: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_8_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-sym_8_blur'
				},
				spine: {
					shift: {
						x: -1,
						y: -1
					},
					src: 'spine-symbol_h3',
					animations: {
						win: 'win'
					},
					skin: 'default'
				},
				sounds: {
					win: 'high_2',
					cheap: 'high_2_cheap'
				}
			}
		}
	}],
	['8', { // hight
		symbol: ArSymbol,
		config: {
			type: 'high',
			valuable: 8,
			default: {
				static: {
					shift: {
						x: 0.5,
						y: 0.5
					},
					texture: 'symbols-sym_9'
				},
				dimm: {
					shift: {
						x: 0.5,
						y: 0.5
					},
					texture: 'symbols-sym_9_dimm'
				},
				spin: {
					shift: {
						x: 0.5,
						y: 0.5
					},
					texture: 'symbols-sym_9_blur'
				},
				spine: {
					shift: {
						x: -0.5,
						y: -0.5
					},
					src: 'spine-symbol_h4',
					animations: {
						win: 'win'
					},
					skin: 'default'
				},
				sounds: {
					win: 'high_3',
					cheap: 'high_3_cheap'
				}
			}
		}
	}],
	['9', { // hight
		symbol: ArSymbol,
		config: {
			type: 'high',
			valuable: 9,
			default: {
				static: {
					shift: {
						x: 0.5,
						y: 1
					},
					texture: 'symbols-sym_10'
				},
				dimm: {
					shift: {
						x: 0.5,
						y: 1
					},
					texture: 'symbols-sym_10_dimm'
				},
				spin: {
					shift: {
						x: 0.5,
						y: 1
					},
					texture: 'symbols-sym_10_blur'
				},
				spine: {
					shift: {
						x: -0.5,
						y: 0
					},
					src: 'spine-symbol_h5',
					animations: {
						win: 'win'
					},
					skin: 'default'
				},
				sounds: {
					win: 'high_4'
				}
			}
		}
	}],
	['10', { // FAKE symbol. Need to pass tests
		symbol: ArSymbol,
		config: {
			type: 'high',
			valuable: 9,
			default: {
				static: {
					shift: {
						x: 0.5,
						y: 1
					},
					texture: 'symbols-sym_10'
				},
				dimm: {
					shift: {
						x: 0.5,
						y: 1
					},
					texture: 'symbols-sym_10_dimm'
				},
				spin: {
					shift: {
						x: 0.5,
						y: 1
					},
					texture: 'symbols-sym_10_blur'
				},
				spine: {
					shift: {
						x: -0.5,
						y: 0
					},
					src: 'spine-symbol_h5',
					animations: {
						win: 'win'
					},
					skin: 'default'
				},
				sounds: {
					win: 'high_5'
				}
			}
		}
	}],
	['11', {// FS
		symbol: Bonus,
		config: {
			type: 'scatter',
			valuable: 0,
			overMask: true,
			default: {
				static: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-fs'
				},
				dimm: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-fs_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-fs_blur'
				},
				spine: {
					shift: {
						x: 0,
						y: -1
					},
					src: 'spine-symbol_fs',
					animations: {
						win: 'win'
					},
					skin: 'default'
				},
				sounds: {
					// win: 'bonus_landed_3',
					// land: 'bonus_landed_1'
				}
			},
		},
	}],
	['12', { // Type: "add" plus blue
		symbol: Multiplier,
		config: {
			type: 'scatter',
			valuable: 0,
			overMask: false, //if true, it is over the expanded wild
			multiplier: {
				panelAsset: 'symbols-rectangle_add',
				bitmapFontName: 'bitmap-symbol-add',
				operation: '+',
				position: { x: 138, y: 136 }
			},
			default: {
				static: {
					shift: {
						x: -1,
						y: -15
					},
					texture: 'symbols-blue_rocket'
				},
				dimm: {
					shift: {
						x: -1,
						y: -15
					},
					texture: 'symbols-blue_rocket_dimm'
				},
				spin: {
					shift: {
						x: -1,
						y: -15
					},
					texture: 'symbols-blue_rocket_blur'
				},
				spine: {
					shift: {
						x: 0,
						y: 0
					},
					src: 'spine-symbol_multiplier',
					animations: {
						row_0: '1_rocket_blue_short',
						row_1: '1_rocket_blue_mid_up',
						row_2: '1_rocket_blue_mid',
						row_3: '1_rocket_blue_mid_down',
						row_4: '1_rocket_blue_high',
					},
					// skin: 'firework_blue'
				},
				sounds: {
					multiply: 'symbol-multiplier-1'
				}
			},
		},
	}],
	['13', { // type : "multi"
		symbol: Multiplier,
		config: {
			type: 'scatter',
			valuable: 0,
			overMask: false,
			multiplier: {
				panelAsset: 'symbols-rectangle_mult',
				bitmapFontName: 'bitmap-symbol-mult',
				operation: 'x',
				position: { x: 138, y: 136 }
			},
			default: {
				static: {
					shift: {
						x: -1,
						y: -15
					},
					texture: 'symbols-red_rocket'
				},
				dimm: {
					shift: {
						x: -1,
						y: -15
					},
					texture: 'symbols-red_rocket_dimm'
				},
				spin: {
					shift: {
						x: -1,
						y: -15
					},
					texture: 'symbols-red_rocket_blur'
				},
				spine: {
					shift: {
						x: 0,
						y: 0
					},
					src: 'spine-symbol_multiplier',
					animations: {
						row_0: '1_rocket_red_short',
						row_1: '1_rocket_red_mid_up',
						row_2: '1_rocket_red_mid',
						row_3: '1_rocket_red_mid_down',
						row_4: '1_rocket_red_high',
					},
					// skin: 'firework_red'
				},
				sounds: {
					multiply: 'symbol-multiplier-2'
				}
			},
		},
	}],
	['14', {// Type: "epicAdd" allPlus blue
		symbol: Multiplier,
		config: {
			type: 'scatter',
			valuable: 0,
			overMask: false,
			multiplier: {
				panelAsset: 'symbols-rectangle_add',
				bitmapFontName: 'bitmap-symbol-add',
				operation: '+',
				position: { x: 138, y: 136 }
			},
			default: {
				static: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-blue_rockets'
				},
				dimm: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-blue_rockets_dimm'
				},
				spin: {
					shift: {
						x: 0,
						y: 0
					},
					texture: 'symbols-blue_rockets_blur'
				},
				spine: {
					shift: {
						x: -3,
						y: 2
					},
					src: 'spine-symbol_multiplier',
					animations: {
						row_0: '5_rockets',
						row_1: '5_rockets',
						row_2: '5_rockets',
						row_3: '5_rockets',
						row_4: '5_rockets',
					},
					// skin: 'firework_blue'
				},
				sounds: {
					multiply: 'symbol-multiplier-3'
				}
			},
		},
	}],
	['15', {// 'epicMulti" allMultiply red
		symbol: Multiplier,
		config: {
			type: 'scatter',
			valuable: 0,
			overMask: false,
			multiplier: {
				panelAsset: 'symbols-rectangle_mult',
				bitmapFontName: 'bitmap-symbol-mult',
				operation: 'x',
				position: { x: 138, y: 136 }
			},
			default: {
				static: {
					shift: {
						x: -2,
						y: -13
					},
					texture: 'symbols-red_rockets'
				},
				dimm: {
					shift: {
						x: -2,
						y: -13
					},
					texture: 'symbols-red_rockets_dimm'
				},
				spin: {
					shift: {
						x: -2,
						y: -13
					},
					texture: 'symbols-red_rockets_blur'
				},
				spine: {
					shift: {
						x: 0,
						y: 0
					},
					src: 'spine-symbol_multiplier',
					animations: {
						row_0: '3_rockets',
						row_1: '3_rockets',
						row_2: '3_rockets',
						row_3: '3_rockets',
						row_4: '3_rockets',
					},
					// skin: 'firework_red'
				},
				sounds: {
					multiply: 'symbol-multiplier-4'
				}
			},
		},
	}]
]);
